import { useStaticQuery, graphql } from 'gatsby';

export default function useChemistryType() {
    const data = useStaticQuery(graphql`
        query globalNav {
            storyblokGlobalConfig {
                story {
                    content {
                        global_nav {
                            promo_cards {
                                title
                                body
                                link {
                                    url
                                    cached_url
                                }
                                link_label
                                image {
                                    filename
                                }
                            }

                            promo_links {
                                title
                                body
                                link {
                                    url
                                    cached_url
                                }
                            }

                            menu_primary {
                                component
                                label
                                link {
                                    url
                                }
                                title
                                items {
                                    component
                                    title
                                    body
                                    description
                                    featured
                                    link_label
                                    link {
                                        url
                                    }
                                    items {
                                        label
                                        sub_text
                                        link {
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return data?.storyblokGlobalConfig?.story?.content?.global_nav[0] ?? {};
}
